export default {
  inherits: "baseTheme",
};
